/* Top Shot Players — Founding Player pre-sale modal (design handoff option
   1c, 20 Aug 2026) + Founders Club badge.
   Modal: one primary action (pre-order at the founding price), email capture
   collapsed behind a text link, live D/H/M countdown + time-elapsed bar,
   7-day dismissal, focus trap, focus restore. Auto-opens once per visitor
   after a short delay, never on the buy page and never over the open cart
   drawer. Badge: bottom-left tab that re-opens the modal; its own ✕ hides
   it; gone for good once the visitor has joined. */
(function () {
  "use strict";

  var modal = document.getElementById("tsp-game-modal");
  var badge = document.getElementById("tsp-founders-badge");
  if (!modal) return;

  var DISMISS_KEY = "tspPopupDismissed";   /* timestamp (ms); 7-day TTL */
  var JOINED_KEY = "tspPopupJoined";
  var BADGE_KEY = "tspBadgeDismissed";
  var DISMISS_TTL = 7 * 24 * 60 * 60 * 1000;
  var POPUP_DELAY = 4000;
  var BADGE_DELAY = 1500;

  var card = modal.querySelector(".fp-card");
  var form = document.getElementById("game-email-form");
  var emailRow = modal.querySelector("[data-fp-email-row]");
  var emailToggle = modal.querySelector("[data-fp-email-toggle]");
  var emailInput = document.getElementById("popup-email-input");
  var emailErr = document.getElementById("popup-email-err");
  var doneEl = document.getElementById("game-success");
  var cdD = modal.querySelector("[data-fp-d]");
  var cdH = modal.querySelector("[data-fp-h]");
  var cdM = modal.querySelector("[data-fp-m]");
  var bar = modal.querySelector("[data-fp-bar]");

  /* ---- Deadline / pre-sale window (single source of truth = theme settings,
     shared with every other clock on the site via window.tspCountdown) ---- */
  var end = (window.tspCountdown && window.tspCountdown.end) || Date.parse(modal.getAttribute("data-deadline") || "");
  var start = Date.parse(modal.getAttribute("data-presale-start") || "");
  var over = !end || isNaN(end) || end - Date.now() <= 0;

  function track(ev, props) {
    if (window.tspTrack) { try { window.tspTrack(ev, Object.assign({ source: "popup" }, props || {})); } catch (e) {} }
  }
  function flag(key, value) {
    try { localStorage.setItem(key, value === undefined ? "1" : String(value)); } catch (e) {}
  }
  function has(key) {
    try { return localStorage.getItem(key) === "1"; } catch (e) { return false; }
  }
  function dismiss() { flag(DISMISS_KEY, Date.now()); }
  function isDismissed() {
    var v; try { v = localStorage.getItem(DISMISS_KEY); } catch (e) { return false; }
    if (!v) return false;
    var t = parseInt(v, 10);
    /* legacy "1" (pre-20 Aug) parses to 1 → expired → shows the new design once */
    return !isNaN(t) && Date.now() - t < DISMISS_TTL;
  }

  /* ---- Countdown + time bar: 1 s tick, only while the modal is open ---- */
  var timer = null;
  function pad(n) { return String(n).padStart(2, "0"); }
  function tick() {
    var now = Date.now();
    var ms = Math.max(0, end - now);
    if (cdD) cdD.textContent = pad(Math.floor(ms / 864e5));
    if (cdH) cdH.textContent = pad(Math.floor(ms / 36e5) % 24);
    if (cdM) cdM.textContent = pad(Math.floor(ms / 6e4) % 60);
    if (bar && !isNaN(start) && end > start) {
      var pct = Math.min(100, Math.max(0, ((now - start) / (end - start)) * 100));
      bar.style.width = pct.toFixed(2) + "%";
      var track_ = bar.parentElement;
      if (track_) track_.setAttribute("aria-valuenow", Math.round(pct));
    }
    if (ms <= 0) { stopTick(); closeModal("expired"); }
  }
  function startTick() { tick(); if (!timer) timer = setInterval(tick, 1000); }
  function stopTick() { if (timer) { clearInterval(timer); timer = null; } }

  /* ---- Badge ---- */
  function showBadge() {
    if (!badge || !badge.hidden || over) return;
    if (has(BADGE_KEY) || has(JOINED_KEY)) return;
    badge.hidden = false;
    requestAnimationFrame(function () { badge.classList.add("show"); });
    track("badge_shown");
  }
  function hideBadge(method) {
    if (!badge || badge.hidden) return;
    badge.classList.remove("show");
    setTimeout(function () { badge.hidden = true; }, 250);
    if (method) track("badge_dismissed", { method: method });
  }

  /* ---- Email slot states ---- */
  function setEmailOpen(open, focus) {
    if (!emailRow || !emailToggle) return;
    emailRow.hidden = !open;
    emailToggle.setAttribute("aria-expanded", open ? "true" : "false");
    if (!open) clearError();
    if (open && focus && emailInput) emailInput.focus();
  }
  function showDone() {
    if (emailToggle) emailToggle.hidden = true;
    if (form) form.hidden = true;
    if (doneEl) doneEl.hidden = false;
  }
  function showError(msg) {
    if (!emailErr) return;
    emailErr.textContent = msg;
    emailErr.hidden = false;
    if (emailInput) emailInput.setAttribute("aria-invalid", "true");
  }
  function clearError() {
    if (!emailErr) return;
    emailErr.hidden = true;
    emailErr.textContent = "";
    if (emailInput) emailInput.removeAttribute("aria-invalid");
  }
  /* Spec copy: empty → "Enter your email", malformed → "That email doesn't look right" */
  function validateEmail() {
    var v = (emailInput.value || "").trim();
    if (!v) { showError("Enter your email"); return "empty"; }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) { showError("That email doesn’t look right"); return "malformed"; }
    clearError();
    return null;
  }

  /* ---- Modal open / close, focus management ---- */
  var opener = null;
  function focusables() {
    return Array.prototype.filter.call(
      modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'),
      function (el) { return !el.hidden && !el.disabled && el.offsetParent !== null; }
    );
  }
  function openModal(via, trigger) {
    if (!modal.hidden || over) return;
    opener = trigger || (document.activeElement !== document.body ? document.activeElement : null);
    modal.hidden = false;
    document.body.classList.add("fp-modal-open");
    requestAnimationFrame(function () {
      modal.classList.add("show");
      /* spec: initial focus on the card itself, not the close button */
      if (card) card.focus({ preventScroll: true });
    });
    startTick();
    track("popup_open", { via: via || "auto" });
  }
  function closeModal(method) {
    if (modal.hidden) return;
    modal.classList.remove("show");
    document.body.classList.remove("fp-modal-open");
    stopTick();
    dismiss();
    track("popup_dismissed", { method: method || "close" });
    setTimeout(function () { modal.hidden = true; }, 250);
    if (opener && typeof opener.focus === "function" && document.contains(opener)) {
      try { opener.focus({ preventScroll: true }); } catch (e) {}
    }
    opener = null;
  }

  modal.addEventListener("click", function (e) {
    /* Primary CTA: cart.js's delegated .js-add-to-cart handler (document
       level, runs after this) adds set:1 and opens the drawer. Close the
       modal first so the drawer lands on the page, not on the card. */
    var cta = e.target.closest("[data-popup-cta]");
    if (cta) {
      cta.setAttribute("aria-busy", "true");
      track("popup_cta_clicked", { cta: cta.getAttribute("data-popup-cta") });
      closeModal("preorder");
      setTimeout(function () { cta.removeAttribute("aria-busy"); }, 600);
      return;
    }
    if (e.target.closest("[data-fp-email-toggle]")) {
      var open = emailRow && emailRow.hidden;
      setEmailOpen(open, true);
      track("popup_email_toggled", { open: !!open });
      return;
    }
    var closer = e.target.closest("[data-game-close]");
    if (closer) {
      closeModal(closer.classList.contains("fp-modal-scrim") ? "backdrop" : "close");
    }
  });
  document.addEventListener("keydown", function (e) {
    if (modal.hidden) return;
    if (e.key === "Escape") { closeModal("escape"); return; }
    if (e.key === "Tab") {
      /* focus trap */
      var els = focusables();
      if (!els.length) { e.preventDefault(); if (card) card.focus(); return; }
      var first = els[0], last = els[els.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === card)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-badge-close]")) {
      flag(BADGE_KEY);
      hideBadge("close");
      return;
    }
    var btn = e.target.closest("[data-game-open]");
    if (!btn) return;
    e.preventDefault();
    openModal(btn.getAttribute("data-game-open") || "button", btn);
  });

  if (form && emailInput) {
    var submitBtn = form.querySelector(".fp-email-submit");
    emailInput.addEventListener("blur", function () {
      if ((emailInput.value || "").trim() || !emailErr.hidden) validateEmail();
    });
    emailInput.addEventListener("input", clearError);
    /* Validate BEFORE a submit event exists: Shopify's storefront hCaptcha
       hooks form submits at the document level, so an empty/malformed entry
       that reached `submit` could pop a captcha challenge. Intercept the
       click and the Enter key instead; only valid input ever submits. */
    function guard(e) {
      var reason = validateEmail();
      if (reason) {
        e.preventDefault();
        emailInput.focus();
        track("popup_email_invalid", { reason: reason });
        return false;
      }
      return true;
    }
    if (submitBtn) submitBtn.addEventListener("click", guard);
    emailInput.addEventListener("keydown", function (e) {
      if (e.key === "Enter" && !guard(e)) e.stopPropagation();
    });
    form.addEventListener("submit", function (e) {
      if (!guard(e)) return;
      /* Native Shopify customer post; never re-nag someone who signed up. */
      dismiss();
    });
  }

  /* Back from a successful signup — return_to carries the marker, which
     keeps footer/homepage capture forms from triggering this modal. The
     confirmation line replaces the row in the same slot (spec). */
  if (/[?&]popup_joined=1/.test(location.search)) {
    dismiss();
    flag(JOINED_KEY);
    showDone();
    openModal("success_return");
    return;
  }

  /* Badge: every page (CSS hides it on the mobile shop page). */
  setTimeout(showBadge, BADGE_DELAY);

  /* Server-side form errors re-render the page with the modal closed —
     reopen it with the email row expanded so the message is seen. */
  if (modal.hasAttribute("data-has-errors")) {
    setEmailOpen(true, false);
    openModal("errors");
    return;
  }

  /* Auto-open: once per 7 days, never mid-purchase, never after the deadline. */
  if (over || isDismissed() || has(JOINED_KEY)) return;
  if (/^\/pages\/golfer/.test(location.pathname)) return;
  setTimeout(function () {
    if (document.querySelector(".cart-drawer.show")) return;
    openModal();
  }, POPUP_DELAY);
})();
